import { useNavigate } from 'react-router-dom'

export const PRODUCTS_URL = '/assembly/detail/:transferId/:docNum/products'

export const useGoToProducts = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, docNum: string, containers: string[]) => {
      const url = `${PRODUCTS_URL.replace(':transferId', transferId).replace(
        ':docNum',
        docNum
      )}?containers=${containers.join(',')}`
      navigate(url)
    }
  }
}
